import React from 'react'
import { Alert } from 'reactstrap'

export default ({ message }) => <Alert color='danger'>{message}</Alert>
